<template>
  <div class="flex items-center gap-12">
    <!-- Avatar -->
    <div
      class="w-40 h-40 desk:w-48 desk:h-48 flex flex-col items-center justify-center shrink-0 rounded-full"
      :class="{
        'bg-brandPrimary': userStore.isSalesRepUser,
        'bg-purpleLight': userStore.isLoggedIn && !userStore.isSalesRepUser,
        'bg-warningLight': userStore.isCustomerSuccessUser,
      }"
    >
      <!-- Sales rep -->
      <img
        v-if="userStore.isSalesRepUser"
        alt="sales rep"
        src="/icons/smiley-cool.svg"
        class="w-[26px] h-[26px] desk:w-32 desk:h-32"
      >
      <!-- Customer -->
      <img
        v-if="userStore.isLoggedIn && !userStore.isSalesRepUser && !userStore.isCustomerSuccessUser"
        alt="customer"
        src="/icons/smiley-purple.svg"
        class="w-24 h-24 desk:w-32 desk:h-32"
      >
      <!-- Customer service -->
      <img
        v-if="userStore.isCustomerSuccessUser"
        alt="customer service"
        src="/icons/headset.svg"
        class="w-24 h-24 desk:w-32 desk:h-32"
      >
    </div>

    <!-- Name -->
    <div class="shrink type-xs-medium desk:type-sm-medium leading-single">
      <div class="line-clamp-1">
        <!-- Sales rep and Customer -->
        <div
          v-if="userStore.isLoggedIn && !userStore.isCustomerSuccessUser"
          class="flex flex-col gap-4"
        >
          <span class="line-clamp-1">{{ userStore.userProfile.firstName }} {{ userStore.userProfile.lastName }}</span>
          <span class="font-normal text-dark">{{ userStore.userProfile.email }}</span>
        </div>
        <!-- Customer service -->
        <div
          v-else
          class="flex flex-col gap-4"
        >
          <span class="line-clamp-1">{{ userStore.userProfile.lastName }}</span>
          <span class="font-normal text-dark">{{ userStore.userProfile.email }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { useUserStore } from '~/store/user';

const userStore = useUserStore();

</script>

<style lang="postcss">

</style>
